// Locale strings of report 2.5 (account-statement), accountant's document 2026-10-03.
// Merged ONCE into finance.reports2.<camelCaseSlug> by ./index.js: use
// $t("finance.reports2.<camelCaseSlug>.<key>"). Owned by this report only.
export default {
  pageTitle: "كشف حساب مفصّل",
  title: "كشف حساب مفصّل",

  mode_detailed: "تفصيلي",
  mode_summarized: "مجمّع",
  mode_party: "حسب الطرف",
  mode_entry: "حسب القيد",
  mode_comparative: "مقارن",

  account: "الحساب",
  includeChildren: "تضمين الحسابات الفرعية",
  partyType: "نوع الطرف",
  party: "الطرف",
  party_captain: "سائق",
  party_center: "مركز شحن",
  party_business: "حساب أعمال (مؤسسة)",
  party_owner: "مالك سيارة",
  partyPickerHint: "ابحث بالاسم أو الهاتف أو الرقم أو رمز الحساب",
  partyMore: "تُعرض أول {limit} نتيجة فقط: اكتب جزءاً من الاسم أو رقم الهاتف أو رمز الحساب لتضييق البحث.",
  partyNoResults: "لا يوجد طرف مطابق",
  partyDeleted: "محذوف",
  partyNoAccount: "لا يملك حساباً في الدليل",
  partyFailedLoad: "تعذر تحميل قائمة الأطراف",
  entryNumber: "رقم القيد",
  entryNumberHint: "رقم القيد (مثل JE-...) أو رقمه الداخلي",
  periodA: "الفترة الحالية",
  periodB: "الفترة المقارنة",
  periodAFrom: "الفترة الحالية من",
  periodATo: "الفترة الحالية إلى",
  periodBFrom: "الفترة المقارنة من",
  periodBTo: "الفترة المقارنة إلى",
  groupBy: "التجميع",
  month: "الشهر",
  week: "الأسبوع (يبدأ السبت)",
  movementType: "نوع الحركة",
  allMovements: "كل الحركات",
  amountMin: "المبلغ من",
  amountMax: "المبلغ إلى",
  search: "بحث (مرجع، بيان، رقم قيد)",

  pickAccount: "اختر حساباً لعرض كشفه",
  pickParty: "اختر نوع الطرف والطرف",
  pickEntry: "أدخل رقم القيد",

  level: "المستوى",
  parentAccount: "الحساب الأب",
  normalBalance: "طبيعة الرصيد",
  yes: "نعم",
  source: "المصدر",
  event: "الحدث",
  booking: "الرحلة",
  createdBy: "أنشئ بواسطة",
  system: "النظام",
  createdAt: "تاريخ الإنشاء",
  reverseOf: "عكس للقيد",
  reversedBy: "معكوس بالقيد",

  reconciliation: "المطابقة مع ميزان المراجعة",
  reconciliationDifference: "الفرق",
  reconciliationLedger: "رصيد دفتر الأستاذ",
  filteredNotice: "عرض مُصفّى: الرصيد الجاري هو الرصيد الحقيقي بعد كل سطر",
  provisional: "مبدئية",

  colDate: "التاريخ",
  colEntryNo: "رقم القيد",
  colDescription: "البيان",
  colReference: "المرجع",
  colNature: "طبيعة الرصيد",
  colNotes: "ملاحظات",
  abnormalSuffix: "(غير طبيعي)",

  opening: "الرصيد الافتتاحي",
  closing: "الرصيد الختامي",
  carriedForward: "رصيد منقول",
  periodTotal: "إجمالي الفترة",
  filteredTotal: "إجمالي السطور المعروضة",
  linesWord: "حركة",
  rowsTotal: "عدد الحركات",
  loadingLines: "جارٍ تحميل الحركات...",

  accountKind: "نوع الحساب",
  sharedAccount: "حساب مشترك - سطور هذا السائق فقط",
  noPartyAccounts: "لا توجد حسابات مرتبطة بهذا الطرف",
  partyTotal: "إجمالي الطرف",

  movementsCount: "عدد الحركات",
  totalDebit: "إجمالي المدين",
  totalCredit: "إجمالي الدائن",
  netMovement: "صافي الحركة",

  item: "البند",
  value: "القيمة",
  difference: "الفرق",
  changePct: "نسبة التغيّر",

  sheetInfo: "بيانات الكشف",
  sheetLines: "الحركات",
  sheetPartyAccounts: "حسابات الطرف",
};
